export const getNodesConnection = (nodes, ...args) => (
  args.map((id) => (
    nodes.find((node) => node.id === id)
  ))
);
